(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('assetUtility', assetUtility);

	function assetUtility(_, utility, uriUtility, assetCommonConfig) {
		function getBestFormatsForSize(asset, desiredSize, formatPrefix) {
			var closestSize = null;
			var bestFormats = _(asset.formats || [])
				.filter(function (f) {
					var firstFile = f.file || (f.files && f.files[0]);
					return f.name && utility.startsWith(f.name, assetCommonConfig.previewFormatPrefix) && firstFile && firstFile.mediaType && utility.startsWith(firstFile.mediaType, formatPrefix + '/');
				})
				.map(function (f) {
					var previewSize = f.name.substring(assetCommonConfig.previewFormatPrefix.length);
					previewSize = parseInt(previewSize.trim(), 10);

					return previewSize && {
						format: f,
						size: previewSize
					};
				})
				.compact()
				.groupBy(function (f) {
					return f.size >= desiredSize ? 'formatsLargerThanDesired' : 'formatsSmallerThanDesired';
				})
				.value();

			return _(bestFormats.formatsLargerThanDesired ?
					bestFormats.formatsLargerThanDesired :
					bestFormats.formatsSmallerThanDesired ?
						bestFormats.formatsSmallerThanDesired : [])
				.sortBy(function (f) {
					return Math.abs(desiredSize - f.size);
				})
				.take(function (f) {
					if (closestSize === null)
						closestSize = f.size;

					return f.size === closestSize;
				})
				.value();
		}

		return {
			getBestFormatForSize: function (asset, size) {
				var bestFormats = getBestFormatsForSize(asset, size, 'image');
				return bestFormats && bestFormats[0] && bestFormats[0].format;
			},
			getBestThumbnailForSize: function (asset, size, assetServiceBaseUri) {
				var formats = getBestFormatsForSize(asset, size, 'image');
				var bestFormat = formats[0] && formats[0].format;

				var previewFile = bestFormat && (bestFormat.file || bestFormat.files && bestFormat.files[0]);

				return previewFile && {
					fileId: previewFile.id,
					width: previewFile.metadata.image.width,
					height: previewFile.metadata.image.height,
					url: uriUtility.fromPattern(assetServiceBaseUri + 'assets/{assetId}/files/{fileId}/content', { assetId: asset.id, fileId: previewFile.id, rev: asset.revision.id })
				};
			},
			getVideoSourcesForSize: function (asset, size, assetServiceBaseUri) {
				if (!asset.formats)
					return [];

				return _(getBestFormatsForSize(asset, size, 'video'))
					.map(function (f) {
						return {
							src: uriUtility.fromPattern(assetServiceBaseUri + 'assets/{assetId}/files/{fileId}/content', { assetId: asset.id, fileId: f.format.file.id, rev: asset.revision.id }),
							type: f.format.file.mediaType,
							height: f.size
						};
					})
					.sort(function (a, b) {
						// Video playback is flaky in Chrome when webm isn't first in the list
						return a.type.indexOf('webm') >= 0 ?
							-1 :
							b.type.indexOf('webm') >= 0 ?
								1 : 0;
					})
					.value();
			},
			getAudioSources: function (asset, assetServiceBaseUri) {
				var formats = asset.formats || [];
				var files = [asset.file].concat(formats.map(function (format) { return format.file; }));

				return _(files)
					.filter(function (file) {
						return file.mediaType && utility.startsWith(file.mediaType, 'audio/');
					})
					.map(function (file) {
						return {
							src: uriUtility.fromPattern(assetServiceBaseUri + 'assets/{assetId}/files/{fileId}/content', { assetId: asset.id, fileId: file.id, rev: asset.revision.id }),
							type: file.mediaType
						};
					})
					.value();
			}
		};
	}
	assetUtility.$inject = ['_', 'utility', 'uriUtility', 'assetCommonConfig'];
})();
